import { EventEmitter, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CasinoGameModel, CasinoSliderListModel } from '@components/casino/casino.model';
import { ApiService } from '@services/api.service';
import { environment } from '@environments/environment';

@Injectable()
export class CasinoHelper {
  favList: number[] = [];
  favListListener: EventEmitter<any> = new EventEmitter();
  favChangeListener: EventEmitter<any> = new EventEmitter();
  selectProviderListener: EventEmitter<any> = new EventEmitter();
  selectCategoryListener: EventEmitter<any> = new EventEmitter();
  goGamesListener: EventEmitter<any> = new EventEmitter();
  goGamesDataListener: EventEmitter<any> = new EventEmitter();
  public casinoSliderImageList: CasinoSliderListModel = new CasinoSliderListModel({
    response: [],
    windowWidth: window.innerWidth,
  });

  constructor(private _snackBar: MatSnackBar, private _ApiService: ApiService) {}

  getSliderApiCall() {
    this._ApiService.getCasinoSlider().then(res => {
      if (Array.isArray(res) && res.length > 0) {
        this.casinoSliderImageList = new CasinoSliderListModel({
          response: res,
          windowWidth: window.innerWidth,
        });
      }
    });
  }
  snackbarWarningMessage(msgType: string, msgText: string): void {
    if (msgType === 'success') {
      this._snackBar
        .open(msgText, 'X', {
          duration: 5000,
          panelClass: ['snackbar-custom', 'success-snackbar'],
          verticalPosition: 'bottom',
        })
        .afterDismissed();
    } else if (msgType === 'error') {
      this._snackBar
        .open(msgText, 'X', {
          duration: 5000,
          panelClass: ['snackbar-custom', 'error-snackbar'],
          verticalPosition: 'bottom',
        })
        .afterDismissed();
    }
  }

  setFavList(favList: number[]) {
    this.favList = favList;
    this.favListListener.emit(favList);
  }
  selectCasinoProvider(provider: number) {
    this.selectProviderListener.emit(provider);
  }
  selectCasinoCategory(categoryId: number) {
    this.selectCategoryListener.emit(categoryId);
  }
  goGamesAction(gameData: CasinoGameModel) {
    this.goGamesListener.emit(gameData);
  }
}
